/**
* @file 详情页模板
* @author Ice(chenzhouji@baidu.com)
*/
import {useEffect} from 'react';

type SeoProps = {
    title: string
    keywords: string
    description: string
};

export default ({title, keywords, description}: SeoProps): void => useEffect(() => {
    const createMeta = (name: string, content: string) => {
        const meta = document.createElement('meta');
        meta.setAttribute('name', name);
        meta.setAttribute('content', content);
        return meta;
    };

    const kmeta = createMeta('keywords', keywords);
    const dmeta = createMeta('description', description);

    document.title = title;
    document.head.appendChild(kmeta);
    document.head.appendChild(dmeta);
}, [title, keywords, description]);
